import script from "./Disclaimer.vue?vue&type=script&setup=true&lang=ts"
export * from "./Disclaimer.vue?vue&type=script&setup=true&lang=ts"

import "./Disclaimer.vue?vue&type=style&index=0&id=40697c6c&lang=scss"

const __exports__ = script;

export default __exports__